import { MDSHoverContentGroup } from "./hover-content-group";

export enum MDSHoverContentPlacement {
  Above = "above",
  Below = "below",
  BelowRightAlignment = "below-right-alignment",
  Right = "right",
}

export interface MDSHoverContentProps {
  isTouchDevice?: boolean;
  children: React.ReactNode;
  content: (args: MDSHoverContentArgs) => React.ReactNode;
  group?: MDSHoverContentGroup;
  requireClick?: boolean;
  placement?: MDSHoverContentPlacement;
}

export interface MDSHoverContentArgs {
  hide: () => void;
}
